import { generateId, random, sample } from '@/utils';

export type GeneratePosition = (size: number) => React.CSSProperties;

export interface SparkleType {
  id: string;
  color: string;
  size: number;
  numOfPoints?: number;
  createdAt: number;
  style: React.CSSProperties;
}

export const defaultGeneratePosition: GeneratePosition = (
  size: number
) => {
  let style: React.CSSProperties = {};
  style.left = random(0, 100) + '%';
  style.zIndex = sample([1, 3])[0];

  if (Math.random() > 0.5) {
    style.top = size * 0.5;
  } else {
    style.bottom = -size * 0.5;
  }

  return style;
};

export const generateSparkle = (
  colors: Array<string>,
  minSize: number,
  maxSize: number,
  generatePosition: GeneratePosition
): SparkleType => {
  const size = random(minSize, maxSize);

  return {
    id: generateId(),
    color: sample(colors)[0],
    size,
    numOfPoints: 4,
    createdAt: Date.now(),
    style: generatePosition(size),
  };
};
